import React from "react";
import get from "lodash/get";
import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";

import CollectionName from "../../molecules/collection-name";
import StoryCard5 from "../../molecules/story-card5";
import StoryCard6 from "../../molecules/story-card6";

import "./seven-stories.m.css";

const SevenStories = ({ collection, page }) => {
  if (!collection && !collection?.items) {
    return null;
  }

  const stories = page === "not-found" ? collection.items : filterStory(collection);

  if (!stories) {
    return null;
  }

  const adUnitId = get(collection, ["associated-metadata", "adUnitId"], "");

  return (
    <>
      <CollectionName collection={collection} />
      <div styleName="wrapper">
        <div styleName="col1">
          {stories?.splice(0, 1).map((item, index) => (
            <StoryCard5 story={item} key={index} />
          ))}
        </div>
        <div styleName="col2 col2-wrapper">
          {stories?.splice(0, 3).map((item, index) => (
            <StoryCard6 story={item} key={index} headerType={4} />
          ))}
        </div>
        <div styleName="col2">
          {adUnitId ? (
            <div styleName="ad-wrapper" className="hide-mobile">
              <AdContainer
                AdClassName="standard-336x280"
                id={`home_desktop_seven_stories_ad-${collection.id}`}
                desktop={adUnitId}
              />
            </div>
          ) : (
            stories?.splice(0, 3).map((item, index) => <StoryCard6 story={item} key={index} headerType={4} />)
          )}
        </div>
      </div>
    </>
  );
};

export default SevenStories;
